import React from "react";
import { connect } from "react-redux";
import Router from "next/router";

import style from "./style.scss";

import { fetchUrl, routerPush } from "../../config/utils";
import { setInitLoaded, setAccount } from "../../store";

import pvpChars from "../../config/pvpChars.json";
import inits from "../../engine/inits";
import RenderCharacters from "../../engine/renderCharacters";

import CreateLink from "../createLink/index";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faTimes,
    faSignOutAlt,
    faUserPlus,
    faGamepad,
    faTrophy,
    faBookOpen,
    faComments,
    faCircle,
    faSignInAlt,
    faChevronDown,
    faChevronUp
} from "@fortawesome/free-solid-svg-icons";

import RegisterForm from "../registerForm/index";

import MobileDetect from "mobile-detect";

class Header extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            openModalCharacters: false,
            characters: [],
            charactersPvP: pvpChars,
            typeGame: "PvE",
            loadCharacters: false,
            buttonCreatePj: "Creación deshabilitada",
            // Login/Register dropdown
            loginOpen: false,
            loginView: "login", // "login" | "register"
            loginName: "",
            loginPassword: "",
            loginError: "",
            // Pulse animation del botón Login cuando el user clickea
            // Jugar sin estar logueado — guía visual hacia donde mirar.
            loginBtnPulse: false
        };

        this.canvasCharacter = [];
    }

    async componentDidMount() {
        this._unmounted = false;
        const { loadCharacters } = this.state;
        const { dispatch, account } = this.props;

        if (account.accountId && !loadCharacters) {
            this.setState({ loadCharacters: true });
            this.getAllCharacters();
        }

        this.canvasCharacter.map((canvas, index) => {
            if (canvas) this.canvasCharacter[index].ctx = canvas.getContext("2d");
        });

        // Cierra el dropdown de login al hacer click afuera.
        document.addEventListener("click", this.handleOutsideClick);

        // ─────────────────────────────────────────────────────────
        // inits.initialize() carga 6 JSONs pesados (heads, bodies,
        // graphics, cascos, armas, escudos). Antes corría síncrono acá
        // y competía con el fetch de las otras páginas (ranking,
        // wiki), causando que la primera navegación se viera lenta /
        // con estilos rotos en el primer paint.
        //
        // Solo /play los necesita realmente. En el resto de páginas
        // los podemos diferir hasta después del first paint usando
        // requestIdleCallback (con setTimeout fallback) para que la
        // red y el main thread queden libres durante el render inicial.
        // ─────────────────────────────────────────────────────────
        const deferInitsLoad = () => {
            if (this._unmounted) return;
            inits.initialize().then(() => {
                if (this._unmounted) return;
                dispatch(setInitLoaded(true));
            });
        };

        if (typeof window !== "undefined" && window.requestIdleCallback) {
            window.requestIdleCallback(deferInitsLoad, { timeout: 1500 });
        } else {
            setTimeout(deferInitsLoad, 0);
        }
    }

    componentWillUnmount() {
        this._unmounted = true;
        document.removeEventListener("click", this.handleOutsideClick);
    }

    // Wrapper safe — evita "setState on unmounted component" warnings.
    safeSetState = (...args) => {
        if (this._unmounted) return;
        this.setState(...args);
    };

    handleOutsideClick = e => {
        if (this.loginRef && !this.loginRef.contains(e.target)) {
            this.setState({ loginOpen: false, loginView: "login" });
        }
    };

    clearCanvas = () => {
        this.canvasCharacter.map((canvas, index) => {
            if (this.canvasCharacter[index] && this.canvasCharacter[index].ctx) {
                this.canvasCharacter[index].ctx.clearRect(0, 0, 80, 100);
            }
        });
    };

    getAllCharacters = async () => {
        const result = await fetchUrl("/characters");
        // El user puede navegar a otra page mientras este request resuelve.
        if (this._unmounted) return;
        this.setState({ characters: result || [] });
    };

    changeTypeGame = async typeGame => {
        await this.setState({
            typeGame,
            buttonCreatePj:
                typeGame === "PvP"
                    ? "Crear Personaje"
                    : "Creación deshabilitada"
        });
        this.renderCharacters();
    };

    renderCharacters = () => {
        this.clearCanvas();
        const { characters, charactersPvP, typeGame } = this.state;
        const tmpCharacters = typeGame == "PvE" ? characters : charactersPvP;
        tmpCharacters.map((character, index) => {
            const canvas = this.canvasCharacter[index];
            if (!canvas || !canvas.ctx) return;
            const rndChar = new RenderCharacters(
                inits,
                canvas.ctx,
                character,
                24,
                60
            );
            rndChar.drawChar();
        });
    };

    play = (character, key) => {
        const { account } = this.props;
        const { typeGame } = this.state;

        if (!character) {
            this.setState({ openModalCharacters: false });
            // El form de creación de char vive embebido en /play (debajo del
            // grid del lobby). Mandamos al user ahí.
            return routerPush("/play");
        }

        // idAccount + email = account-wide (localStorage, compartido entre tabs).
        // idCharacter/idChar/typeGame = per-tab (sessionStorage), permite
        // jugar con chars distintos en tabs distintos del mismo browser.
        window.localStorage.setItem("idAccount", account.accountId);
        window.localStorage.setItem("email", account.email);
        if (typeGame == "PvE") {
            window.sessionStorage.setItem("idCharacter", character._id);
        } else {
            window.sessionStorage.setItem("idChar", key);
        }
        window.sessionStorage.setItem(
            "typeGame",
            typeGame == "PvE" ? 1 : 2
        );

        return routerPush("/play", "", true);
    };

    renderBoxCharacters = () => {
        const { characters, charactersPvP, typeGame } = this.state;
        let html = [];
        for (let i = 0; i < 10; i++) {
            const character =
                typeGame === "PvE" ? characters[i] : charactersPvP[i];
            html.push(
                <div className={style.contentGral} key={i}>
                    <span className={style.name}>
                        {character ? character.name : ""}
                    </span>
                    <canvas
                        ref={ref => {
                            this.canvasCharacter[i] = ref;
                        }}
                        className={style.contentImgA}
                        onClick={() => this.play(character, i)}
                        width="80"
                        height="100"
                    />
                </div>
            );
        }
        return html;
    };

    openPlayModal = e => {
        // CRITICAL: stopImmediatePropagation en el nativeEvent para que el
        // `handleOutsideClick` (registrado con document.addEventListener) no
        // se ejecute después de este onClick. Sin esto, el flow era:
        //   1. React onClick → setState({loginOpen: true})
        //   2. Event sigue bubbleando al document
        //   3. handleOutsideClick: click target NO está en loginRef → cierra
        //      el dropdown que acabamos de abrir
        //   4. Resultado neto: nada cambia → "el botón Jugar no hace nada"
        // stopImmediatePropagation NATIVO frena los listeners posteriores en
        // el document. React's e.stopPropagation() NO basta (solo para el
        // tree sintético de React, no para document.addEventListener).
        if (e && e.nativeEvent && e.nativeEvent.stopImmediatePropagation) {
            e.nativeEvent.stopImmediatePropagation();
        }

        const { account, userAgent } = this.props;

        const md = new MobileDetect(userAgent);
        if (md.mobile()) {
            alert("Argentum Online Web no está disponible para celulares.");
            return;
        }
        // Si no está logueado, abrir el dropdown del navbar Y pulsar el
        // botón de login para que el user lo vea (antes era silencioso y
        // parecía que el botón Jugar no hacía nada).
        if (!account.accountId) {
            this.setState({
                loginOpen: true,
                loginView: "register",
                loginBtnPulse: true
            });
            // Quita la animación de pulse después de un segundo para que
            // pueda re-dispararse si el user vuelve a clickear Jugar.
            setTimeout(() => {
                if (!this._unmounted) {
                    this.setState({ loginBtnPulse: false });
                }
            }, 1200);
            return;
        }

        // Si ya estamos en /play, routerPush al mismo destino es no-op
        // de Next.js → el click "no hace nada" desde el POV del usuario.
        // Forzamos un reload soft con Router.replace para que se monte la
        // lobby fresh (útil si el user salió del juego y quiere volver al
        // selector de personajes).
        const currentPath =
            (Router.router && Router.router.pathname) || "";
        if (currentPath === "/play") {
            Router.replace("/play");
            return;
        }

        routerPush("/play");
    };

    // ── Login form (dropdown) ─────────────────────────────────
    handleLoginInput = e => {
        this.setState({
            [e.target.name]: e.target.value,
            loginError: ""
        });
    };

    handleLogin = async e => {
        if (e && e.preventDefault) e.preventDefault();
        const { dispatch } = this.props;
        const { loginName, loginPassword } = this.state;

        if (!loginName || !loginPassword) {
            this.setState({ loginError: "Ingresá usuario y contraseña" });
            return;
        }

        const result = await fetchUrl("/login", {
            method: "POST",
            body: JSON.stringify({
                name: loginName,
                password: loginPassword
            }),
            headers: { "Content-Type": "application/json" },
            credentials: "include"
        });

        if (this._unmounted) return;

        if (result.error) {
            this.setState({ loginError: result.message || "Error" });
            return;
        }

        dispatch(setAccount(result));
        this.setState({
            loginOpen: false,
            loginName: "",
            loginPassword: "",
            loginError: ""
        });
    };

    handleLogout = () => {
        const { dispatch } = this.props;
        dispatch(setAccount({}));
        fetchUrl("/logout", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            credentials: "include"
        });
    };

    toggleLogin = e => {
        e.stopPropagation();
        const willOpen = !this.state.loginOpen;
        this.setState({
            loginOpen: willOpen,
            loginView: willOpen ? this.state.loginView : "login"
        });
    };

    switchView = (view, e) => {
        if (e && e.preventDefault) e.preventDefault();
        this.setState({ loginView: view, loginError: "" });
    };

    handleRegisterSuccess = () => {
        this.setState({ loginOpen: false, loginView: "login" });
    };

    render() {
        const {
            openModalCharacters,
            typeGame,
            loadCharacters,
            buttonCreatePj,
            loginOpen,
            loginView,
            loginName,
            loginPassword,
            loginError,
            loginBtnPulse
        } = this.state;
        const { account } = this.props;

        if (
            typeof window !== "undefined" &&
            account.accountId &&
            !loadCharacters
        )
            this.getAllCharacters();

        return (
            <React.Fragment>
                <div className={style.navbar}>
                    {/* Logo izquierda */}
                    <CreateLink href="/">
                        <a className={style.logoLink}>
                            <span className={style.logoText}>
                                <span className={style.logoMain}>
                                    Argentum<span className={style.logoSeparator}>&nbsp;</span>Online
                                </span>
                                <span className={style.logoAccent}>Web</span>
                            </span>
                        </a>
                    </CreateLink>

                    {/* Nav centro — "Inicio" removido; el logo del lado
                        izquierdo (ARGENTUMONLINEWEB) ahora routea a "/". */}
                    <nav className={style.navLinks}>
                        <a
                            className={style.navItem}
                            onClick={this.openPlayModal}
                        >
                            <FontAwesomeIcon icon={faGamepad} />
                            <span>Jugar</span>
                        </a>

                        <CreateLink href="/ranking">
                            <a className={style.navItem}>
                                <FontAwesomeIcon icon={faTrophy} />
                                <span>Ranking</span>
                            </a>
                        </CreateLink>

                        <CreateLink href="/wiki">
                            <a className={style.navItem}>
                                <FontAwesomeIcon icon={faBookOpen} />
                                <span>Wiki</span>
                            </a>
                        </CreateLink>

                        <CreateLink href="/forum">
                            <a className={style.navItem}>
                                <FontAwesomeIcon icon={faComments} />
                                <span>Foro</span>
                            </a>
                        </CreateLink>
                    </nav>

                    {/* Cuenta + servidor derecha */}
                    <div className={style.accountSection}>
                        <div className={style.serverStatus}>
                            <FontAwesomeIcon
                                icon={faCircle}
                                className={style.statusDot}
                            />
                            <span>Servidor Online</span>
                        </div>

                        {account.accountId ? (
                            <div className={style.userBox}>
                                <span className={style.userName}>
                                    {account.name}
                                </span>
                                <button
                                    type="button"
                                    className={style.logoutBtn}
                                    onClick={this.handleLogout}
                                    title="Cerrar sesión"
                                >
                                    <FontAwesomeIcon icon={faSignOutAlt} />
                                    <span>Salir</span>
                                </button>
                            </div>
                        ) : (
                            <div
                                className={style.loginWrap}
                                ref={ref => {
                                    this.loginRef = ref;
                                }}
                            >
                                <button
                                    type="button"
                                    className={`${style.loginBtn} ${loginOpen ? style.loginBtnOpen : ""} ${loginBtnPulse ? style.loginBtnPulse : ""}`}
                                    onClick={this.toggleLogin}
                                >
                                    <FontAwesomeIcon
                                        icon={faSignInAlt}
                                        className={style.loginBtnIcon}
                                    />
                                    <span>Login</span>
                                    <FontAwesomeIcon
                                        icon={faChevronDown}
                                        className={style.loginBtnChevron}
                                    />
                                </button>

                                {loginOpen && (
                                    <div className={style.loginDropdown}>
                                        <div className={style.dropdownTitle}>
                                            Bienvenido de vuelta
                                        </div>
                                        <div className={style.dropdownSubtitle}>
                                            Ingresá a tu cuenta para jugar
                                        </div>
                                        <form
                                            className={style.dropdownForm}
                                            onSubmit={this.handleLogin}
                                        >
                                            <input
                                                type="text"
                                                name="loginName"
                                                placeholder="Usuario"
                                                value={loginName}
                                                onChange={this.handleLoginInput}
                                                className={style.dropdownInput}
                                                autoComplete="username"
                                                autoFocus
                                            />
                                            <input
                                                type="password"
                                                name="loginPassword"
                                                placeholder="Contraseña"
                                                value={loginPassword}
                                                onChange={this.handleLoginInput}
                                                className={style.dropdownInput}
                                                autoComplete="current-password"
                                            />
                                            {loginError ? (
                                                <span
                                                    className={
                                                        style.dropdownError
                                                    }
                                                >
                                                    {loginError}
                                                </span>
                                            ) : null}
                                            <button
                                                type="submit"
                                                className={style.dropdownSubmit}
                                            >
                                                Entrar
                                            </button>
                                        </form>

                                        <div className={style.dropdownDivider}>
                                            <span>nuevo en Argentum</span>
                                        </div>

                                        <button
                                            type="button"
                                            className={`${style.dropdownRegister} ${loginView === "register" ? style.dropdownRegisterActive : ""}`}
                                            onClick={e =>
                                                this.switchView(
                                                    loginView === "register"
                                                        ? "login"
                                                        : "register",
                                                    e
                                                )
                                            }
                                        >
                                            <FontAwesomeIcon
                                                icon={
                                                    loginView === "register"
                                                        ? faChevronUp
                                                        : faUserPlus
                                                }
                                            />
                                            <span>
                                                {loginView === "register"
                                                    ? "Cancelar registro"
                                                    : "Crear cuenta gratis"}
                                            </span>
                                        </button>

                                        {loginView === "register" && (
                                            <div
                                                className={
                                                    style.registerSection
                                                }
                                            >
                                                <RegisterForm
                                                    onSuccess={
                                                        this
                                                            .handleRegisterSuccess
                                                    }
                                                />
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                </div>

                {/* Modal de selección de personajes (sin cambios funcionales) */}
                <div
                    className={style.modalPlay}
                    style={{ display: openModalCharacters ? "block" : "none" }}
                >
                    <div className={style.shadow}>
                        <div className={style.header}>
                            <div className={style.selectTypeGame}>
                                <button
                                    className={
                                        typeGame === "PvE" ? style.selected : ""
                                    }
                                    onClick={() => this.changeTypeGame("PvE")}
                                >
                                    PvE
                                </button>
                                <button
                                    className={
                                        typeGame === "PvP" ? style.selected : ""
                                    }
                                    onClick={() => this.changeTypeGame("PvP")}
                                >
                                    PvP
                                </button>
                            </div>

                            <FontAwesomeIcon
                                icon={faTimes}
                                className={style.closeWindow}
                                onClick={() =>
                                    this.setState({
                                        openModalCharacters: !openModalCharacters
                                    })
                                }
                            />
                        </div>

                        {this.renderBoxCharacters()}

                        <div
                            className={style.createCharacter}
                            data-js="createCharacter"
                        >
                            <CreateLink href="/play">
                                <a className={style.buttonRegister}>
                                    {buttonCreatePj}
                                </a>
                            </CreateLink>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

function mapStateToProps(state) {
    const { account } = state;
    return { account };
}

export default connect(mapStateToProps)(Header);
